import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedUserResolverService } from '@aveva/connect-web-core';
import { AuthenticatedUserAccountResolverService } from 'erm-sdk';
import { ErmDevOpsGuard } from './erm-devops.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountListComponent } from './account-list/account-list.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { EnvironmentListComponent } from './environment-list/environment-list.component';
import { EnvironmentDetailsComponent } from './environment-details/environment-details.component';
import { DevopsActionsListComponent } from './devops-actions/devops-actions-list.component';
import { UnauthorizedComponent } from './authorization/unauthorized.component';
import { UnauthorizedGuard } from './authorization/unauthorized.guard';
import { AlarmListComponent } from './alarms/alarm-list.component';
import { CreateDevopsActionComponent } from './create-devops-action/page/create-devops-action.component';
import { FleetUsersComponent } from './fleet-users/fleet-users.component';
import { LayoutComponent } from './components/layout/layout.component';

const routes: Routes = [
  {
    path: 'erm',
    component: LayoutComponent,
    resolve: {
      user: AuthenticatedUserResolverService,
      account: AuthenticatedUserAccountResolverService
    },
    canActivate: [ErmDevOpsGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'accounts',
        component: AccountListComponent
      },
      {
        path: 'accounts/:accountId',
        component: AccountDetailsComponent
      },
      {
        path: 'customers',
        component: CustomerListComponent
      },
      {
        path: 'customers/:customerId',
        component: CustomerDetailsComponent
      },
      {
        path: 'environments',
        component: EnvironmentListComponent
      },
      {
        path: 'environments/:environmentId',
        component: EnvironmentDetailsComponent
      },
      {
        path: 'devops-actions',
        component: DevopsActionsListComponent
      },
      {
        path: 'create-devops-actions',
        component: CreateDevopsActionComponent
      },
      {
        path: 'fleet-users/:customerId',
        component: FleetUsersComponent
      },
      {
        path: 'alarms',
        component: AlarmListComponent
      }
    ]
  },
  {
    path: 'unauthorized/:errorCode',
    component: UnauthorizedComponent,
    canActivate: [UnauthorizedGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErmDevOpsRoutingModule { }
